import { render, staticRenderFns } from "./BaseSection.vue?vue&type=template&id=4d9ca1d1&scoped=true&"
import script from "./BaseSection.vue?vue&type=script&lang=ts&"
export * from "./BaseSection.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSection.vue?vue&type=style&index=0&id=4d9ca1d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9ca1d1",
  null
  
)

export default component.exports